<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    @onConfirm="confirm"
    :isConfirm="isConfirm"
    :width="width"
  >
    <div slot="content">
      <el-form
        ref="form"
        label-width="150px"
        :model="dataForm"
        :disabled="isdisableds"
        :rules="editFormRules"
      >
        <el-form-item label="会员类型：">
            <el-radio-group v-model="dataForm.Type" @change="changeType">
                <el-radio :label="1">个人</el-radio>
                <el-radio :label="2">团体</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="所属会员:">
            <el-select v-model="dataForm.UserId" placeholder="请选择" @change="changeName">
                <el-option
                v-for="item in memberList"
                :key="item.UserId"
                :label="item.Name"
                :value="item.UserId"
                ></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="会员级别：" prop="Level">
          <el-select v-model="dataForm.Level" placeholder="请选择">
            <el-option
              v-for="item in levelOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="缴费金额：">
            <el-input v-model="dataForm.Amount" placeholder="请输入缴费金额"></el-input>
        </el-form-item>
        <el-form-item label="缴费时间：">
            <el-date-picker
                v-model="dataForm.BankReceiveTime"
                type="datetime"
                placeholder="选择日期时间">
            </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfUpload from "@/components/controls/of_upload/of_upload";
import { mapGetters } from "vuex";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null
    },
    formTitle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      editFormRules: {
      },
      isConfirm: false,
      isdisableds: false,
      ishide: false,
      activeValue: 1,
      inactiveValue: 0,
      hideUploadEdit: false,
      //会员等级
      levelOptions: [
        { value: 0, label: "普通会员" },
        { value: 1, label: "特殊会员" },
        { value: 2, label: "永久会员" }
      ],
      isEdit: false,
      fileList: [],
      limitNum: 1,
      width: "50%",
      dialogVisible: false,
      dialogImageUrl: "",
      FrontImage: [],
      BackImage: [],
      hideFrontImage: false,
      hideBackImage: false,
      fileList2: [],
      hideUploadEdit2: false,
      memberList: []
    };
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"])
  },
  components: {
    OfDialog,
    OfUpload
  },
  mounted() {
      this.getMemberList(1)
  },
  methods: {
    changeName(id) {
      let vm = this
      vm.dataForm.Name = vm.memberList.find(x=>x.UserId == id).Name
    },
    changeType(type) {
      let vm = this
      vm.dataForm.Type = type
      vm.dataForm.UserId = ''
      vm.getMemberList(type)
    },
    getMemberList(type) {
        let vm = this
        const request = {
            type: type
        }
        api.GetMemberTree(request).then(res => {
            if (res.data.Code === 0) {
                vm.memberList = res.data.Data
            }
        })
    },
    cancel() {
      this.$emit("formCallBack", null);
    },
    //新增
    confirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.isConfirm = true;
          let params = Object.assign({}, this.dataForm);
          params.BankReceiveTime = params.BankReceiveTime / 1000
          params.Amount = Number(params.Amount)
          api.AddMemberPay(params)
            .then(rep => {
              this.isConfirm = false;
              if (rep.data.Code === 0) {
                this.$message({
                  message: "提交成功",
                  type: "success"
                });
                this.$emit("formCallBack", params);
              } else {
                this.$message({
                  message: rep.data.Message,
                  type: "error"
                });
              }
            })
            .catch(e => {
              this.isConfirm = false;
              this.$message({
                message: e.toString(),
                type: "error"
              });
            });
        }
      });
    }
  }
};
</script>

<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}

.el-date-editor >>> .el-input__icon {
  display: none;
}

.el-date-editor >>> .el-input__inner {
  width: 90%;
}

/* .el-date-editor >>> .el-input__inner {
  width: 512.8px;
}
.el-select >>> .el-input__inner {
  width: 512.8px;
} */
</style>

<style>
.hide .el-upload--fileList {
  display: none;
}
.idcardimg_contain {
  position: relative;
}
.idcardimg {
  position: absolute;
  z-index: 5;
  top: 30%;
  left: 25%;
}
</style>
